import { createFileRoute, useNavigate } from '@tanstack/react-router'
import SlideWizard from '@/components/learning-paths/SlideWizard'
import { landscapeOfDeceptionChapter } from '@/learning-paths/incode/landscape-of-deception/chapter'

export const Route = createFileRoute('/_auth/learning-journeys/new-age-of-scams')({
  component: LandscapeOfDeceptionRoute,
})

function LandscapeOfDeceptionRoute() {
  const navigate = useNavigate()

  const handleExit = () => {
    navigate({ to: '/learning-journeys/scam-fundamentals', search: { invitationcode: undefined, __clerk_ticket: undefined } })
  }

  return (
    <SlideWizard
      chapter={landscapeOfDeceptionChapter}
      onExit={handleExit}
      onComplete={handleExit}
    />
  )
}
